import {
  saveCustomList,
  getCustomList
}from '@/api/common'
import dayjs from "dayjs";
import html2canvas from 'html2canvas';

// 读取缓存
export function getStorage(name){
  return JSON.parse(window.sessionStorage.getItem(name)) 
}

// 写入缓存
export function setStorsage(name,obj){
  window.sessionStorage.setItem(name,JSON.stringify(obj))
}

// 清除所有缓存
export function clearStorsage(){
  window.sessionStorage.clear()
}

// 清楚缓存
export function clearNameStorsage(name){
  window.sessionStorage.removeItem(name)
}

export function setLocal(name,obj){
  window.localStorage.setItem(name,JSON.stringify(obj))
}

// 写入Cookie
export function setCookie(name, value){ 
  const now = new Date();
  const midnight = new Date();
  
  // 设置为今天 24:00:00（即明天的 00:00:00）
  midnight.setHours(24, 0, 0, 0);
  
  document.cookie = `${name}=${value}; expires=${midnight.toUTCString()}; path=/`;
}

// 删除Cookie
export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

// 读取Cookie
export function getCookie(name) { 
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split('=');
    if (cookie[0] === name) {
      return cookie[1];
    }
  }
  return null;
}

export function getLocal(name){
  return JSON.parse(window.localStorage.getItem(name)) 
}

export function clearLocal(name){
  window.localStorage.removeItem('header')
  window.localStorage.removeItem('message')
  window.localStorage.removeItem('power')
  deleteCookie('token')
  // window.localStorage.clear()
}

export function removeLocal(name){
  window.localStorage.removeItem (name)
}

// 用于后台传回二进制数据处理成文件并下载
export const downFileStream = (blob, name) => {
  // const url = window.URL.createObjectURL(blob)
  // var binarry = []
  // binarry.push(blob)
  // const url = window.URL.createObjectURL( new Blob(binarry)) 
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', name)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  // window.URL.revokeObjectURL(url)
  URL.revokeObjectURL(url)
}

// 传入url 实现复制到粘贴板
export const getClipboardContents = async (url) =>{
  try {
    const imgURL = url   // 'https://co-logistics.cn/api/uploads/user_image/1.png'; 谷歌里只支持png
    const data = await fetch(imgURL);
    const blob = await data.blob();
    await navigator.clipboard.write([
      new ClipboardItem({
        [blob.type]: blob
      })
    ]);
    console.log('Image copied.');
  } catch (err) {
    console.error(err.name, err.message);
  }
}

// 集装箱箱号校验
export function CalculateCheckDigit (code) {
  const containerNumber = code.toUpperCase();  
    var regex = /^[A-Z]{4}\d{7}$/;
    if (!regex.test(containerNumber)) {
        return false;
    }
  const charToValue = {
      '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
      'A': 10, 'B': 12, 'C': 13, 'D': 14, 'E': 15, 'F': 16, 'G': 17, 'H': 18, 'I': 19, 'J': 20,
      'K': 21, 'L': 23, 'M': 24, 'N': 25, 'O': 26, 'P': 27, 'Q': 28, 'R': 29, 'S': 30, 'T': 31,
      'U': 32, 'V': 34, 'W': 35, 'X': 36, 'Y': 37, 'Z': 38
  };

  var weights = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512];

  let sum = 0;
  for (let i = 0; i < 10; i++) {
      sum += charToValue[containerNumber[i]] * weights[i];
  }

  let checkDigit = sum % 11;
  if(checkDigit==10){
    checkDigit = 0
  }

  if(checkDigit == containerNumber[10]){
    return true
  }else{
    return false;
  }
}

// 处理自定义列表
/**
 * 
 * @param {*} 缓存字段 
 * @param {*} 获取类型 
 * @param {*} allCustomData 
 * @param {*} reset 重置
 * @returns 
 */
export async function getCustomListData(name,type,allCustomData,reset){
  if(reset){
    removeLocal(name)
  }
  // if(getLocal(name)){
  //   return getLocal(name);
  // }else{
    const res = await getCustomList({type: type});
    let targetKeys = res.data.data;
    const list = [];
    for(let i = 0; i < targetKeys.length; i++){
      const item = allCustomData.find(custom=>custom.key==targetKeys[i])
      if(item!=undefined){
        list.push(item)
      }
    }

    setLocal(name,list)
    return list;
  // }
}

// 时间格式化
export function formData(date){
  return dayjs(date).format("YYYY-MM-DD");
}

export function formDataDay(date){
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
}


// 下载url 文件
export function downloadFile(url,name){
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  a.remove();
}

// 复制文本，保留
export function copyText(text){
  const textArea = document.createElement('textarea')
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.style.position = 'absolute'
  textArea.style.opacity = '0'
  textArea.style.left = '-999999px'
  textArea.style.top = '-999999px'
  textArea.focus()
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
}

// 将字符串的首字母大写，其它小写
export function capitalizeWords(string) {
  return string.split(' ').map(word => {
    if (!word) return word; // 处理空字符串的情况
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
}

// 视频生成封面
export function getVideoCover(file) { 
  const videoElement = document.createElement('video');
  videoElement.preload = 'auto';
  videoElement.src = URL.createObjectURL(file);

  videoElement.addEventListener('loadeddata', () => {
    videoElement.currentTime = 0; // 定位到第一帧
  });

  videoElement.addEventListener('seeked', () => {
    const canvas = document.createElement('canvas');
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

    // 将第一帧转换为图片文件（Blob）
    canvas.toBlob((blob) => {
      const coverFile = new File([blob], 'cover.jpg', { type: 'image/jpeg' });

      // 返回图片文件
      return coverFile;

    }, 'image/jpeg', 0.8); // 调整画质
  });

}

// 复制图片
export async function copyImage (url){
    if(navigator.clipboard && window.ClipboardItem){
      const imgURL = url 
      // const data = await fetch(imgURL,{
      //   mode: 'cors'
      // });

      // 获取图片的数据
      // const blob = await data.blob(); // 转为blob类型
      const blob = await imageUrlToBlobViaCanvas(imgURL);
      await navigator.clipboard.write([ // 调用写入方法
        new ClipboardItem({ // 创建一个 ClipboardItem
          [blob.type]: blob 
        })
      ]);
    }else{
      throw new Error("当前浏览器暂不支持！");
    }
}

/**
 * clipboard 只支持png 的图片，图片转为png
 * @param {*} imageUrl 
 * @returns Blob
 */
async function imageUrlToBlobViaCanvas(imageUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // 处理跨域
    
    img.onload = function() {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      
      // 将Canvas转换为Blob
      canvas.toBlob(blob => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Canvas转换Blob失败'));
        }
      }, 'image/png'); // 可以指定格式和质量
    };
    
    img.onerror = () => reject(new Error('图片加载失败'));
    img.src = imageUrl;
  });
}

/**
 * 去除 html标签 
 */
export function removeHtmlTag(str) { 
  return str.replace(/<[^>]+>/g, '');
}

/**
 * 复制html 生成图片
 */
export async function copyHtmlToImage(html) {
  if (navigator.clipboard && window.ClipboardItem) {
    let eleW = html.offsetWidth; // 获得该容器的宽
    let eleH = html.offsetHeight; // 获得该容器的高

    const canvas = await html2canvas(html, { 
      backgroundColor: "#fff",
      useCORS: true,
      allowTaint: true,
      logging: false,
      width: eleW,
      height: eleH,
      scale: window.devicePixelRatio * 2,
    })
    const blob = await new Promise(resolve => {
      canvas.toBlob(resolve, 'image/png');
    });
  
    await navigator.clipboard.write([
      new ClipboardItem({
        'image/png': blob
      })
    ]);
  }else{
    console.warn('当前浏览器不支持Clipboard API或ClipboardItem');
    throw new Error('当前浏览器不支持Clipboard API或ClipboardItem');
    
    // return false;
  }
  
}


/**
 * 对象转 FormData 递归函数
 * @param {Object} obj - 待转换的对象
 */
export function ObjectToFormData(obj){
  const formData = new FormData();

  Object.keys(obj).forEach(key => {
    const value = obj[key];

    // 1. 如果是文件/原始文件对象，直接添加
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
    } 
    // 2. 如果是数组或对象，且不是空，则转为 JSON 字符串
    else if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
      formData.append(key, JSON.stringify(value));
    } 
    // 3. 其他基础类型 (string, number, boolean)
    else {
      formData.append(key, value ?? '');
    }
  });

  return formData;
}



